module.exports = __webpack_public_path__ + "images/6ee0e8284417f87edf41c386fa8d594d-CSP_GoldBadge.png";